<template>
  <svg
    viewBox="0 0 36 36"
    preserveAspectRatio="xMidYMid meet"
    v-on:click="clicked()"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="4" y1="4" x2="33" y2="32" />
    <line x1="4" y1="32" x2="32" y2="4" />
  </svg>
</template>

<script>
export default {
  name: 'CloseIcon',
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
/* This was set for oelde but should be generalized in the future*/
svg {
  width: 24px;
  height: 24px;
}

line {
  stroke: #a2a2a2;
  stroke-width: 6;
  stroke-linecap: round;
}
svg:hover line {
  stroke: #17375c;
}
</style>
